import { useState } from 'react';
import './ReferralModal.css';
import { API_BASE } from '../config';

interface ReferralModalProps {
  onComplete: () => void;
  token: string | null;
}

const DISCOVERY_OPTIONS = [
  { value: '', label: 'Select...' },
  { value: 'internet', label: 'Searching the internet' },
  { value: 'flyer', label: 'Got a flyer / card' },
  { value: 'event', label: 'At an event' },
  { value: 'friend', label: 'From a friend' },
  { value: 'social_media', label: 'Social media' },
  { value: 'podcast', label: 'Podcast' },
  { value: 'other', label: 'Other' },
];

export function ReferralModal({ onComplete, token }: ReferralModalProps) {
  const [discovery, setDiscovery] = useState('');
  const [referredBy, setReferredBy] = useState(() => {
    // Pre-fill from cookie if set
    const match = document.cookie.match(/ws_referral=([^;]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await fetch(`${API_BASE}/v1/profile/referral`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          discoverySource: discovery || undefined,
          referredBy: referredBy.trim() || undefined,
        }),
      });
    } catch {
      // Non-critical — save failed but don't block user
    } finally {
      // Mark as completed locally so modal doesn't show again
      localStorage.setItem('ws_referral_completed', 'true');
      setSubmitting(false);
      onComplete();
    }
  };

  const handleSkip = () => {
    localStorage.setItem('ws_referral_completed', 'true');
    onComplete();
  };

  return (
    <div className="referral-modal__overlay">
      <div className="referral-modal">
        <h2 className="referral-modal__title">Welcome to Hygh Vybe! 🌿</h2>
        <p className="referral-modal__subtitle">Quick question before you dive in — helps us know how people find us.</p>

        <div className="referral-modal__field">
          <label htmlFor="discovery">How did you find out about us?</label>
          <select
            id="discovery"
            value={discovery}
            onChange={(e) => setDiscovery(e.target.value)}
          >
            {DISCOVERY_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        <div className="referral-modal__field">
          <label htmlFor="referredBy">Referred by (optional)</label>
          <input
            id="referredBy"
            type="text"
            value={referredBy}
            onChange={(e) => setReferredBy(e.target.value)}
            placeholder="Name of person who told you about us"
            autoComplete="off"
          />
        </div>

        <div className="referral-modal__actions">
          <button
            type="button"
            className="referral-modal__btn referral-modal__btn--primary"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? 'Saving...' : 'Continue'}
          </button>
          <button
            type="button"
            className="referral-modal__btn referral-modal__btn--skip"
            onClick={handleSkip}
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
}
